import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { getCustomHostTenant, getKnownCustomDomain } from './custom-host'
import {
  isPlatformOnlyPath,
  platformRedirectUrl
} from './custom-host-bootstrap'
import { getHostRole } from './host'

const CANONICAL_ID = 'tenant-custom-domain-canonical'

/**
 * Comportamentos do dominio proprio que dependem da rota atual (Feature #538).
 *
 * - No dominio proprio, a navegacao interna para o painel, o login ou o portal
 *   sai para o endereco da plataforma (D2). O bootstrap cobre so a primeira
 *   carga; um `Link to='/login'` do cabecalho passa por aqui.
 * - Em qualquer host, quando a imobiliaria tem dominio proprio READY, o
 *   `rel=canonical` aponta para ele: o buscador trata o subdominio como copia
 *   e transfere o ranqueamento (D5 — sem 301 nesta entrega).
 */
export default function CustomDomainTracker() {
  const location = useLocation()

  useEffect(() => {
    const tenant = getCustomHostTenant()

    if (
      tenant &&
      getHostRole() === 'custom' &&
      isPlatformOnlyPath(location.pathname)
    ) {
      window.location.replace(platformRedirectUrl(tenant.slug))
      return
    }

    updateCanonical(getKnownCustomDomain(), location.pathname)
  }, [location.pathname])

  return null
}

function updateCanonical(domain: string | null, pathname: string) {
  const existing = document.getElementById(CANONICAL_ID)

  if (!domain) {
    existing?.remove()
    return
  }

  const link = (existing as HTMLLinkElement | null) || createCanonical()
  link.href = `https://${domain}${pathname}`
}

function createCanonical(): HTMLLinkElement {
  const link = document.createElement('link')
  link.id = CANONICAL_ID
  link.rel = 'canonical'
  document.head.appendChild(link)
  return link
}
